/*-------------------------------------------------------------------
グローバル変数
--------------------------------------------------------------------*/
let headerHeight;

/*-------------------------------------------------------------------
関数定義
--------------------------------------------------------------------*/
/**
 * ドロワーを閉じる
 */
function closeDrawer() {
  const $drawer = jQuery('#p-drawer');
  if (!$drawer.length || !$drawer.hasClass('is-opened')) return;

  const ariaControls = 'p-drawer';
  const closingClass = 'is-closing';
  const duration = 350;

  $drawer.addClass(closingClass).removeClass('is-opened');
  jQuery(`[aria-controls=${ariaControls}]`).attr('aria-expanded', 'false').removeClass('is-opened');
  jQuery('body').removeClass('u-overflowHidden');
  setTimeout(function () {
    $drawer.removeClass(closingClass);
  }, duration);
}

/**
 * 同一ページ判定
 */
function isSamePage(url) {
  const current = new URL(location.href);
  const target = new URL(url, location.href);
  const normalizePath = (pathname) => {
    const path = pathname.replace(/\/$/, '');
    if (path === '' || path.endsWith('/index.html')) return '/';
    return path;
  };

  return current.origin === target.origin && normalizePath(current.pathname) === normalizePath(target.pathname);
}

/**
 * スムーススクロール共通処理
 * @param {string} targetId - スクロール先のセレクタ
 * @param {number} speed - アニメーション速度（デフォルト: 500）
 * @param {number|null} offset - オフセット値（デフォルト: headerHeight）
 * @param {Function|null} callback - 完了時のコールバック
 */
function smoothScrollTo(targetId, speed = 500, offset = null, callback = null) {
  const $target = jQuery(targetId);
  if (!$target.length) return;

  const $header = jQuery('.js-header');
  const $headerTarget = jQuery(`.${$header.data('target')}`);
  const threshold = ($headerTarget.length ? $headerTarget.innerHeight() : headerHeight * 1.1);
  const adjustOffset = offset !== null ? offset : headerHeight;
  let position = $target.offset().top;

  if (position > threshold) {
    $header.addClass('is-fixed');
    position -= adjustOffset;
  }

  if (position < 0) {
    position = 0;
  }

  const $scrollElement = jQuery(document.scrollingElement || document.documentElement);
  $scrollElement.stop(true, false).animate({ scrollTop: position }, speed, callback);
}

/**
 * アンカーリンク（他ページからの遷移時）
 */
function scrollHash() {
  const hash = location.hash;
  if (!hash || !jQuery(hash).length) return;

  isHashScrolling = true;
  smoothScrollTo(hash, 500, null, function () {
    isHashScrolling = false;
    hasInitialHash = false;
  });
}

let hasInitialHash = !!location.hash;
let isHashScrolling = false;

// 他ページからのハッシュ遷移時、ブラウザの自動スクロールを抑止
if (location.hash) {
  history.scrollRestoration = 'manual';
  window.scrollTo(0, 0);
}


/*-------------------------------------------------------------------
読み込み時実行
--------------------------------------------------------------------*/
document.addEventListener("DOMContentLoaded", function () {
  headerHeight = document.querySelector('.js-header').offsetHeight;

  if (location.hash) {
    window.scrollTo(0, 0);
  }
});


/*-------------------------------------------------------------------
イベント
--------------------------------------------------------------------*/
/**
 * スクロールバーを除いた画面幅の取得
 */
jQuery(window).on('load resize', function () {
  let vw = document.body.clientWidth;// スクロールバーを除いた幅を取得
  let vh = window.innerHeight; // アドレスバーを覗いた画面高さ
  headerHeight = document.querySelector('.js-header').offsetHeight;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
  document.documentElement.style.setProperty('--vh', `${vh}px`);
  document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
});


/**
 * フェードしたページに戻るときに白飛びする対応
 */
window.addEventListener('pageshow', function (event) {
  if (event.persisted) {
    window.location.reload();
  }
});

jQuery(function () {
  // ページロード完了後にスクロールハッシュを実行
  jQuery(window).on('load', function() {
    scrollHash();
  });

  // スクロール判定
  jQuery(window).on("scroll", function () {
    let scrollTop = jQuery(this).scrollTop();

    /**
     * トップに戻るボタン
     */
    const totop = jQuery('.js-totop');
    const totopTarget = jQuery(`.${totop.data("target")}`);
    if ((totopTarget.length ? totopTarget.innerHeight() : headerHeight) < scrollTop) {
      totop.addClass('is-active');
    } else {
      totop.removeClass('is-active');
    }

  });

  /* ドロワー */
  jQuery(".js-drawer").on("click", function (event) {
    event.preventDefault();
    const ariaControls = jQuery(this).attr("aria-controls");
    const addClass = 'is-opened';
    const closingClass = 'is-closing';
    const duration = 350;
    const $target = jQuery(`#${ariaControls}`);

    if ($target.hasClass(addClass)) {
      $target.addClass(closingClass).removeClass(addClass);
      jQuery(`[aria-controls=${ariaControls}]`).attr("aria-expanded", 'false').removeClass(addClass);
      jQuery('body').removeClass('u-overflowHidden');
      setTimeout(function () {
        $target.removeClass(closingClass);
      }, duration);
    } else {
      $target.removeClass(closingClass).addClass(addClass);
      jQuery(`[aria-controls=${ariaControls}]`).attr("aria-expanded", 'true').addClass(addClass);
      jQuery('body').addClass('u-overflowHidden');
    }

    return false;
  });

  /**
   * ドロワー内のページ内リンククリック時に閉じる
   */
  jQuery('#p-drawer a[href*="#"]').on('click', function () {
    const href = jQuery(this).prop('href');
    if (!isSamePage(href)) return;

    closeDrawer();
  });

  /* FAQアコーディオン */
  jQuery(".p-faq__question").on("click", function (event) {
    event.preventDefault();
    const $details = jQuery(this).closest(".p-faq__details");
    const $answer = $details.children(".p-faq__answer");
    const duration = 300;

    if ($details.hasClass("is-opened")) {
      $answer.stop(true, false).slideUp(duration, function () {
        $details.removeClass("is-opened").removeAttr("open");
      });
    } else {
      $details.addClass("is-opened").attr("open", "");
      $answer
        .stop(true, false)
        .hide()
        .slideDown({
          duration: duration,
          start: function () {
            jQuery(this).css("display", "flex");
          },
        });
    }
  });

  /* ヘッダ */
  jQuery(window).on('load scroll', function () {
    const $header = jQuery('.js-header');
    if ($header.length) {
      const target = jQuery(`.${jQuery($header).data('target')}`);
      const targetHeight = (target.length ? target.innerHeight() : headerHeight * 1.1);
      const position = jQuery(window).scrollTop();

      if (position > targetHeight) {
        $header.addClass('is-fixed');
      } else if (position === 0 && !hasInitialHash && !isHashScrolling) {
        $header.removeClass('is-fixed');
      }
    }
  });


  /* スムーススクロール */
  jQuery(document).on('click', 'a[href*="#"]:not(".js-modal, .js-accordion")', function (e) {
    const href = jQuery(this).prop('href');
    const hash = href.includes('#') ? '#' + href.split('#')[1] : '';

    if (!hash || hash === '#') return;

    if (isSamePage(href)) {
      e.preventDefault();
      closeDrawer();
      smoothScrollTo(hash, 500);
      jQuery(this).blur();
    }
  });

  /* 電話リンク */
  let $ua = navigator.userAgent;
  if ($ua.indexOf("iPhone") < 0 && $ua.indexOf("Android") < 0) {  // PCのとき
    jQuery('a[href^="tel:"]') // 電話リンク
      .css("cursor", "default") // カーソルをポインターにしない
      .css('pointer-events', 'none')  // ホバーなども動作しない
      .on("click", function (e) {
        e.preventDefault();
      });
  }
});
